//export const urlServeur = `https://backcaisse.nusuk.ma`;
//export const urlServeur2 = `https://lagriffe.nusuk.ma/api`;
//export const urlServeur = `http://127.0.0.1:8000`;
export const urlServeur = "https://backcaisse.leajoy.ma"
//export const urlServeur2 = `http://127.0.0.1:8001/api`;
export const colorPrincipale = "#0765AA";
export const devise = " Dhs";
